// Locale-free helpers. Kept apart from index.ts so a consumer can ask about
// direction without pulling every locale JSON into its bundle (the web SPA
// imports this subpath; mobile keeps importing the package root).
export const RTL_LANGUAGES = ['ar', 'ckb'] as const;
export type Language = 'en' | 'ar' | 'ckb';

export function isRtl(lng: string): boolean {
  return (RTL_LANGUAGES as readonly string[]).includes(lng);
}
